module.exports = __webpack_public_path__ + "static/img/son11.63cde19b.png";